import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from './selector';
import { usePermissions } from './PermissionsContext';
import Loader from '../components/Loader';

const ProtectedRoute = ({ component: Component, requiredPermissions, anyPermissions, ...rest }) => {
    const user = useSelector(selectUser);
    const isAuthenticated = useSelector((state) => state.isAuthenticated);
    const { hasPermission, hasAnyPermission, isReady } = usePermissions();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (user && user.isNewUser) {
        return <Navigate to="/change-password" replace />;
    }

    if ((requiredPermissions || anyPermissions) && !isReady) {
        return <Loader />;
    }

    if (requiredPermissions && !hasPermission(requiredPermissions)) {
        return <Navigate to="/unauthorized" replace />;
    }

    if (anyPermissions && !hasAnyPermission(anyPermissions)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Component {...rest} />;
};

export default ProtectedRoute;
